import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    overlay: false,
    token: "",
    estadoTicket: null,
    dataCFDI: null,
    ticket: null,
    isNew: true,
    issue: false
  },
  mutations: {
    setToken(state, token_value) {
      state.token = token_value;
    },
    setOverlay(state, overlay_value) {
      state.overlay = overlay_value;
    },
    setEstadoTicket(state, estadoTicket_value) {
      state.estadoTicket = estadoTicket_value;
    },
    setDataCFDI(state, dataCFDI_value) {
      state.dataCFDI = dataCFDI_value;
    },
    setTicket(state, ticket_value) {
      state.ticket = ticket_value;
    },
    setIsNew(state, isNew_value) {
      state.isNew = isNew_value;
    },
    setIssue(state, issue_value) {
      state.issue = issue_value;
    }
  },
  actions: {

  }
})